<template>
  <span
    @click="addProduct"
    :class="{ checkboxPointer: !wasChecked && !disabled }"
    @mouseenter="toggleAdd()"
    @mouseleave="toggleAdd()"
  >
    <span v-if="wasChecked || isChecked || disabled">
      <img
        v-if="wasChecked"
        :src="styles.checkbox_old"
        alt="check"
        class="pb-1"
        @click="productMandatory"
      />
      <img
        v-else-if="isChecked"
        :src="styles.checkbox_new"
        alt="check"
        class="pb-1"
      />
      <img v-else-if="disabled" :src="styles.x" alt="x" class="pb-1" />
      <span
        :class="{
          'disabled-label': disabled,
          'os-title': !disabled,
        }"
        v-html="description"
      ></span>
    </span>

    <span v-else>
      <!--      <img v-if="addFocus" :src="styles.add_focus" alt="check" class="pb-1" />-->
      <!--      <img v-else :src="styles.add" alt="check" class="pb-1" />-->
      <input type="checkbox" />
      <span
        :class="{
          'disabled-label': disabled,
          'os-title': !disabled,
          'font-weight-bold': fontBold,
        }"
        v-html="description"
      ></span>
    </span>
  </span>
</template>

<script>
export default {
  name: 'OrderCheckbox',
  props: {
    wasChecked: { type: Boolean, default: false },
    isChecked: { type: Boolean, default: false },
    product: {},
    disabled: { type: Boolean, default: false },
    text: { type: String, default: '' },
    styles: {},
    fontBold: { type: Boolean, default: false },
    dontDisplayProductMandatory: { type: Boolean, default: false },
  },
  data() {
    return {
      year: process.env.MIX_AKTU_YEAR,
      addFocus: false,
    };
  },
  computed: {
    description() {
      if (this.text === '') {
        return this.product.OPIS;
      }

      return this.text;
    },
  },
  methods: {
    addProduct() {
      this.$emit('addproduct', this.product);
      if (this.product && this.product.key === 'B') {
        this.$emit('accountantchanged', !this.isChecked);
      }
    },
    toggleAdd() {
      this.addFocus = !this.addFocus;
    },
    productMandatory() {
      if (!this.dontDisplayProductMandatory) {
        this.$bvModal.msgBoxOk(
          'Opcja niemożliwa do samodzielnego odznaczenia. Aby zrezygnować lub zmienić wybraną pozycję skontaktuj się z BOK.',
          {
            title: '',
            size: 'sm',
            buttonSize: 'sm',
            footerClass: 'p-2',
            hideHeaderClose: false,
          }
        );
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
